.segment {
  flex: 1 0 0;
  min-width: var(--sizes-spacing-0-5);
  height: var(--sizes-spacing-1-5);
  border-radius: var(--sizes-radius-full);
  background-color: var(--palette-bg-neutral-medium);
  position: relative;
  overflow: hidden;
}

.fill {
  position: absolute;
  inset-block: 0;
  inset-inline-start: 0;
  width: 100%;
  background-color: var(--palette-bg-neutral-inverse);
}

.unfilled {
  transform: scaleX(0);
}

.reviewed {
  background-color: var(--palette-bg-status-info);
}

.halfStartReviewed {
  background: linear-gradient(to right, var(--palette-bg-neutral-inverse) 50%, var(--palette-bg-status-info) 50%);
}

.halfEndReviewed {
  background: linear-gradient(to right, var(--palette-bg-status-info) 50%, var(--palette-bg-neutral-inverse) 50%);
}

.halfStart {
  width: 50%;
}

.halfEnd {
  inset-inline-start: auto;
  inset-inline-end: 0;
  width: 50%;
}

.label {
  flex: 1 0 0;
  min-width: 0;
  text-align: center;
}
